import { Record } from 'immutable';

const OutstandingInvoiceRecord = Record({
  amountDue: 0,
  date: null,
  daysOverdue: null,
  dueDate: null,
  subTotal: null,
  total: null,
  totalTax: null,
  invoiceNo: null,
  invoiceLink: null,
  invoiceNumber: null,
});

export default class OutstandingInvoice extends OutstandingInvoiceRecord {
  static deserialize(jsonObject = {}) {
    return new OutstandingInvoice(jsonObject);
  }
}
